<div class="admin-page">
  <div *ngIf="isLoading" class="state-message">Loading…</div>

  <!-- The active section's sub-page: a reports-style card grid. The sub-header
       tabs live in the top bar, so there is no in-page heading or tab strip. -->
  <ng-container *ngIf="!isLoading">
    <div *ngIf="cards.length > 0" class="reports-grid">
      <div
        class="report-card"
        *ngFor="let card of cards; trackBy: trackByCard; let i = index"
        [class.disabled]="card.disabled"
        [style.animation-delay.ms]="i * 60"
        role="button"
        tabindex="0"
        (click)="onCardClick(card)"
        (keydown)="onCardKeydown($event, card)">
        <span class="icon-halo">
          <mat-icon class="report-icon">{{ iconFor(card) }}</mat-icon>
        </span>
        <div class="report-title">{{ card.title }}</div>
      </div>
    </div>

    <!-- Empty state — broken-puzzle glyph + message. -->
    <div *ngIf="cards.length === 0" class="empty-state">
      <div class="empty-text">
        No items in {{ activeSection?.title || 'this section' }}
      </div>
      <mat-icon class="empty-icon">extension_off</mat-icon>
    </div>
  </ng-container>
</div>
